export const productModalProps = {
  content: {
    width: '95%',
    maxWidth: 650,
    padding: 0,
    overflowY: 'hidden',
  },
};
